<template>
  <div class="deactivate-complete--wrap">
    <div id="header">
      <h1 class="logo" slot="extra">
        <router-link :to="{ name: 'home' }">
          <i class="icon icon--logo-new"></i>
        </router-link>
      </h1>
    </div>
    <div id="content">
      <content-box :width="'400px'">
        <i class="icon icon--check-green-size50"></i>
        <p class="title">{{ $t('userInfo.myInformation.deactivateComplete.title') }}</p>
        <p class="desc" v-html="$t('userInfo.myInformation.deactivateComplete.desc')"></p>
        <ui-button :primary="true" @click="onGoToHome">
          {{ $t('userInfo.myInformation.deactivateComplete.button') }}
        </ui-button>
      </content-box>
    </div>
  </div>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  components: {
    ContentBox,
    UiButton
  },
  methods: {
    onGoToHome () {
      window.location.href = '/'
    }
  },
  created () {
    if (!this.$route.params.isCompleteUser) {
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.deactivate-complete--wrap {
  min-width: 1024px;
  height: 100%;
  position: relative;
  #header {
    padding-top: 15px;
    padding-left: 15px;
  }
  #content {
    height: calc(100% - 34px);
    /deep/ .content-box {
      @include positionXcenter;
      top: 293px;
      text-align: center;
      padding: 40px;
      box-sizing: border-box;
      border: 2px solid $brandColor;

      .title {
        font-size: 20px;
        font-weight: bold;
        color: #2f2f2f;
        margin-top: 15px;
      }

      .desc {
        font-size: 14px;
        color: #767676;
        margin-top: 15px;
        line-height: 1.43;
      }

      .ui-btn {
        margin-top: 25px;
      }
    }
  }
}
</style>
